exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Rectangle-4 {\n  background-color: #ffffff;\n  border: solid 1px #dfe4e7;\n  padding-right: 20px; }\n\n.table th, .table td {\n  padding: 0rem;\n  padding-right: 0.75rem; }\n\n.ipo {\n  margin-top: 0.5em;\n  width: 63px;\n  height: 27px;\n  font-size: 24px;\n  font-weight: bold;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  color: #231f20; }\n\n.M {\n  font-size: 20px;\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  color: #231f20;\n  margin-bottom: 0rem; }\n\n.ipoFA #ipoFin {\n  text-align: left;\n  width: 800px; }\n\n.ipo-space {\n  white-space: pre-line; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/ipo-executive-summary/ipo-executive-summary.component.scss
// module id = ../../../../../src/app/securities-level/ipo-executive-summary/ipo-executive-summary.component.scss
// module chunks = main